(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
     
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["temperos-stories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('temperos-stories')) {
  customElements.define('temperos-stories', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.cards = [...this.querySelectorAll('[data-tps-card]')];
      this.dialog = this.querySelector('dialog');
      this.video = this.querySelector('video');
      if (!this.dialog || !this.cards.length) return;
      this.cards.forEach((card, index) => card.addEventListener('click', () => {
        this.opener = card;
        this.dialog.showModal();
        this.show(index);
        this.querySelector('[data-tps-close]').focus();
      }));
      this.querySelector('[data-tps-close]').addEventListener('click', () => this.dialog.close());
      this.querySelector('[data-tps-prev]').addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-tps-next]').addEventListener('click', () => this.show(this.index + 1));
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        this.video.pause(); this.video.removeAttribute('src'); this.video.load();
        if (this.opener?.isConnected) this.opener.focus({preventScroll:true});
      });
      this.video.addEventListener('error', () => {if(this.video.getAttribute('src'))this.querySelector('[data-tps-error]').hidden = false;});
      this.visibilityHandler = () => {if(document.hidden)this.video.pause();};
      document.addEventListener('visibilitychange', this.visibilityHandler);
    }
    show(index) {
      const card = this.cards[index]; if(!card)return;
      this.index = index; this.video.pause();
      this.querySelector('[data-tps-title]').textContent = card.dataset.caption;
      this.querySelector('[data-tps-note]').textContent = card.dataset.note;
      this.querySelector('[data-tps-position]').textContent = `${index + 1} / ${this.cards.length}`;
      this.querySelector('[data-tps-prev]').disabled = index === 0;
      this.querySelector('[data-tps-next]').disabled = index === this.cards.length - 1;
      this.querySelector('[data-tps-error]').hidden = true;
      this.video.poster = card.querySelector('img').currentSrc;
      this.video.src = card.dataset.source; this.video.load();
      this.video.play().catch(() => {});
      this.dispatchEvent(new CustomEvent('temperos:video-open',{bubbles:true,detail:{title:card.dataset.caption,index:index+1}}));
    }
    disconnectedCallback(){this.video?.pause();document.removeEventListener('visibilitychange',this.visibilityHandler);}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vita-campaign"] && !Shopify.designMode) return;
  try {
    
  function expireVitaCampaigns() {
    document.querySelectorAll('[data-vita-campaign-end]').forEach((campaign) => {
      const expires = Date.parse(campaign.dataset.vitaCampaignEnd);
      if (Number.isFinite(expires) && Date.now() >= expires) campaign.remove();
    });
  }
  expireVitaCampaigns();
  setInterval(expireVitaCampaigns, 30000);
  document.addEventListener('shopify:section:load', expireVitaCampaigns);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitaalu-147-details"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const link=event.target.closest('.vas a[href="#va-install"]');if(!link)return;const details=document.querySelector('.vac-details #va-install');if(details)details.open=true;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitaalu-compact-details"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const link=event.target.closest('.vas a[href="#va-install"]');if(!link)return;const details=document.querySelector('.vac-details #va-install');if(details)details.open=true;});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitaalu-stories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('vitaalu-stories')) {
  customElements.define('vitaalu-stories', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.cards = [...this.querySelectorAll('[data-vas-card]')];
      this.dialog = this.querySelector('dialog');
      this.video = this.querySelector('video');
      if (!this.dialog || !this.cards.length) return;
      this.cards.forEach((card, index) => card.addEventListener('click', () => {
        this.opener = card;
        this.dialog.showModal();
        this.show(index);
        this.querySelector('[data-vas-close]').focus();
      }));
      this.querySelector('[data-vas-close]').addEventListener('click', () => this.dialog.close());
      this.querySelector('[data-vas-prev]').addEventListener('click', () => this.show(this.index - 1));
      this.querySelector('[data-vas-next]').addEventListener('click', () => this.show(this.index + 1));
      this.dialog.addEventListener('click', event => {
        if (event.target !== this.dialog) return;
        const box = this.dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        this.video.pause(); this.video.removeAttribute('src'); this.video.load();
        if (this.opener?.isConnected) this.opener.focus({preventScroll:true});
      });
      this.video.addEventListener('error', () => {if(this.video.getAttribute('src'))this.querySelector('[data-vas-error]').hidden = false;});
      this.visibilityHandler = () => {if(document.hidden)this.video.pause();};
      document.addEventListener('visibilitychange', this.visibilityHandler);
    }
    show(index) {
      const card = this.cards[index]; if(!card)return;
      this.index = index; this.video.pause();
      this.querySelector('[data-vas-title]').textContent = card.dataset.caption;
      this.querySelector('[data-vas-note]').textContent = card.dataset.note;
      this.querySelector('[data-vas-position]').textContent = `${index + 1} / ${this.cards.length}`;
      this.querySelector('[data-vas-prev]').disabled = index === 0;
      this.querySelector('[data-vas-next]').disabled = index === this.cards.length - 1;
      this.querySelector('[data-vas-error]').hidden = true;
      this.video.poster = card.querySelector('img').currentSrc;
      this.video.src = card.dataset.source; this.video.load();
      this.video.play().catch(() => {});
      this.dispatchEvent(new CustomEvent('vitaalu:video-open',{bubbles:true,detail:{title:card.dataset.caption,index:index+1}}));
    }
    disconnectedCallback(){this.video?.pause();document.removeEventListener('visibilitychange',this.visibilityHandler);}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vitaalu-story"] && !Shopify.designMode) return;
  try {
    
const vitaAluPreviewView = new URL(window.location.href).searchParams.get('view');
if (vitaAluPreviewView === 'vitaalu-conversao') {
  document.addEventListener('change', function (event) {
    if (!event.target.closest('variant-selects')) return;
    const url = new URL(window.location.href);
    url.searchParams.set('view', vitaAluPreviewView);
    window.history.replaceState(window.history.state, '', url);
  });
}

document.addEventListener('click',function(event){const link=event.target.closest('.va-story a[href="#va-product"],.va-story a[data-va-kit]');if(!link)return;const intro=document.querySelector('.va-intro');const main=intro&&intro.closest('section[id^="MainProduct-"]');if(!main)return;if(link.dataset.vaKit){const input=Array.from(main.querySelectorAll('variant-selects input[type="radio"]')).find(input=>input.value===link.dataset.vaKit&&!input.classList.contains('disabled'));if(!input)return;input.click();}event.preventDefault();main.querySelector('product-info').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});});

  } catch(e) { console.error(e); }
})();
})();
